import React, { useContext, useState } from 'react'
import UserContext from '../user-context'
import DashboardContext from '../../layout/dashboard-context'
import Spinner from './../../spinner/spinner'
import MessageContext from '../../message/message-context'
import api from '../../../api'
import { AxiosResponse } from 'axios'
import RoleInfo from '../role-info'

const UserCreation: React.FC = () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [title, setTitle] = useState('')
  const [wordpress] = useState(true)
  const stringArray: Array<string> = []
  const [roles, setRoles] = useState(stringArray)
  const [loading, setLoading] = useState(false)

  const { setSelectedContact } = useContext(UserContext)
  const { contactRoles } = useContext(UserContext)
  const { selectedOrganization } = useContext(DashboardContext)
  const { setMessage, setErrorMessage } = useContext(MessageContext)
  const emailRegex = RegExp('[^@]+@[^.]+..+')

  const customOrder = ['Företagsledare', 'Ordförande BRF', 'Personalansvarig HR ansvarig', 'Uppgiftslämnare lönesummor antal anställda', 'Uppgiftslämnare för lönestatistik', 'Informationsmottagare', 'Huvudkontaktperson'];

  const returnToContactList = () => {
    setSelectedContact({
      id: '',
      name: '',
    })
  }

  const handleCreateUser = async () => {
    const res = await createUser()
    if (!res.contact) {
      return false
    }

    if (res.contact && res.contact.id) {
      returnToContactList()
    }

    if (res.notAddedRoles.length > 0) {
      const values = res.notAddedRoles.toString()
      setErrorMessage(`Max 2 personer tillåtet för rollen:  ${values}`)
    }
  }

  const createUser = async () => {
    if (name && email) {
      if (emailRegex.test(email)) {
        try {
          setLoading(true)
          let res: AxiosResponse<any>
          try {
            res = await api.post(`/accounts/${selectedOrganization.id}/contacts`, {
              name: name,
              email: email,
              phonenumber: phoneNumber,
              title: title,
              wordpress: wordpress,
              roles: roles,
            })
          } catch (e) {
            console.log(e)
            return false
          }
          setLoading(false)
          if (res && res.status === 200) {
            setMessage({ value: 'Användare skapad' })
            return res.data.data
          } else {
            setErrorMessage('Något gick fel vid användarskapandet')
            return false
          }
        } catch (e) {
          setErrorMessage('Något gick fel vid användarskapandet')
          return false
        }
      } else {
        setErrorMessage('Felaktigt formaterad email')
      }
    } else {
      setErrorMessage('Fält saknas')
    }
  }

  const handleChangeRole = (status: boolean, contactRoleKey: string) => {
    if (status && !roles.includes(contactRoleKey)) {
      setRoles([...roles, contactRoleKey])
    } else if (!status && roles.includes(contactRoleKey)) {
      const index = roles.indexOf(contactRoleKey)
      if (index > -1) {
        const newRoles = roles.splice(index, 1)
        setRoles(newRoles)
      }
    }
  }

  return (
    <div className="card p-12 flex flex-col items-center w-full bg-white">
      <div className="flex flex-col w-3/4 items-center">
        <div className="flex justify-between w-full flex-col gap-6">
          <h1>Lägg till användare</h1>
          <form className="w-full flex flex-col gap-3">
            <label className="label">Namn</label>
            <input
              id="nameInput"
              className="input"
              defaultValue=""
              placeholder="Förnamn Efternamn"
              required
              onChange={(e) => setName(e.target.value)}
            />
            <label className="label">Telefonnummer</label>
            <input
              className="input"
              defaultValue=""
              placeholder="021 345 45"
              type="phone"
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
            <label className="label">Email</label>
            <input
              className="input"
              defaultValue=""
              placeholder="Namn@email.com"
              type="email"
              required
              onChange={(e) => setEmail(e.target.value)}
            />

            <label className="label">Jobbtitel</label>
            <input
              className="input"
              defaultValue=""
              placeholder="Ekonom"
              onChange={(e) => setTitle(e.target.value)}
            />
          </form>
          <div className="flex flex-col gap-2">
            <h2>Roller</h2>
            {Object.keys(contactRoles)
              .filter(contactRoleKey => customOrder.includes(contactRoleKey)) 
              .sort((a, b) => customOrder.indexOf(a) - customOrder.indexOf(b)) 
              .map((contactRoleKey, index) => {
              if (contactRoleKey.length > 1) {
                return (
                  <div key={index} className="w-full">
                    <label className="label">
                      <input
                        type="checkbox"
                        className="checkbox"
                        onChange={(e) => {
                          handleChangeRole(e.target.checked, contactRoleKey)
                        }}
                      />
                      {contactRoles[contactRoleKey]}
                    </label>
                  </div>
                )
              }
              return null
            })}
          </div>
        </div>
        <RoleInfo />
        <div className="flex flex-row justify-between items-center w-full py-2">
          <button className="btn-white" onClick={() => returnToContactList()}>
            Tillbaka
          </button>
          {loading ? (
            <Spinner />
          ) : (
            <button className="btn btn-long" onClick={() => handleCreateUser()}>
              Spara
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default UserCreation
